import React, { useState, useEffect } from "react";
import { object, bool, string, number, array } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import StoryMetaData from "../StoryMetaData";

import { getExcerpt } from "../../utils/utils";

import "./customizedMediumStoryCard.m.css";

const CustomizedMediumStoryCard = ({
  story,
  className,
  cardWithImageZoom = true,
  storyHeadlineType = 24,
  widths = [300],
  isExcerpt = false,
  updatedFont,
  publisherLang
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTab, setIsTab] = useState(false);
  const excerpt = getExcerpt(story);

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
    global.deviceWidth > 875 && global.deviceWidth < 1264 && setIsTab(!isTab);
  }, []);

  function getAspectRatio() {
    if (isMobile) {
      return [3, 2];
    } else if (isTab) {
      return [4, 3];
    } else {
      return [16, 9];
    }
  }

  function getImageType() {
    if (isMobile) {
      return "image3x2";
    } else if (isTab) {
      return "image4x3";
    } else {
      return "image16x9";
    }
  }

  const headlineStyle = updatedFont ? `${publisherLang}-story-headline` : "";
  const excerptStyle = `${publisherLang}-excerpt`;
  const subHeadlineStyle = `${publisherLang}-sub-headline`;

  return (
    <div styleName="base" className={`${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""}`}>
      <div styleName="storycard-wrapper" className="storycard-wrapper">
        <Link href={story.url} className="hero-image">
          <CardImage
            className="image-wrapper"
            story={story}
            aspectRatio={getAspectRatio()}
            imageType={getImageType()}
            widths={widths}
            showAlternateImage={true}
          />
        </Link>
        <div>
          {story.subheadline && (
            <Link href={story.url}>
              <Headline
                text={story.subheadline}
                headerLevel={3}
                className="section-name"
                styleName={subHeadlineStyle}
              />
            </Link>
          )}
          <Link href={story.url}>
            <Headline
              text={story.headline}
              headerLevel={3}
              headlineType={storyHeadlineType}
              className="story-headline"
              styleName={headlineStyle}
            />
          </Link>
        </div>
      </div>
      <div className="story-card-details">
        {!isMobile && !isTab && isExcerpt && excerpt && (
          <Link href={story.url}>
            <Headline text={excerpt} headerLevel={5} className="sub-headline" styleName={excerptStyle} />
          </Link>
        )}
        {!isMobile && !isTab && <StoryMetaData story={story} />}
      </div>
    </div>
  );
};

CustomizedMediumStoryCard.propTypes = {
  story: object.isRequired,
  cardWithImageZoom: bool,
  className: string,
  storyHeadlineType: number,
  isPublished: bool,
  widths: array,
  isExcerpt: bool,
  updatedFont: bool,
  publisherLang: string
};

export default CustomizedMediumStoryCard;
